module.exports = __webpack_public_path__ + "feliz-coracao.png?b18518485851dab887f69b846de7365c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emote/feliz-coracao.png
// module id = 112
// module chunks = 0